<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			v-model="form.name"
			:error="inputErrors.name"
			required
			label="שם"
			name="name"
		/>
		<smart-input
			v-model="form.style"
			:error="inputErrors.style"
			label="קובץ עיצוב"
			name="style"
		/>
		<smart-input
			v-model="form.domain"
			:error="inputErrors.domain"
			label="דומיין"
			name="domain"
		/>
		<v-checkbox
			v-model="form.can_share"
			name="out_register"
			label="יכול להוציא משחקים החוצה"
		/>
		<v-checkbox
			v-model="form.out_register"
			name="out_register"
			:label="`הרשמה מבחוץ`"
		/>
		<smart-input
			v-model="form.price"
			type="number"
			:error="inputErrors.price"
			label="מחיר הרשמה"
			name="price"
		/>
		<v-file-input
			:error="inputErrors.logo"
			name="logo"
			type="file"
			label="לוגו"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import OrganizationModule from "src/store/modules/Organization.module";
import FormView from "src/mixins/FormView";

export default {
	name: "OrganizationForm",
	props: [],
	data () {
		return {
			form: {},

		};
	},
	mixins: [new FormView(OrganizationModule, "organization", true)],
	computed: {
		isNew () {
			return !!this.organization.id;
		},
	},
	methods: {
		getData (e) {
			const formData = new FormData(e.target);
			if (this.form.id) {
				formData.id = this.form.id;
			}
			Object.keys(this.form).forEach((key) => {
				const value = this.form[key];
				if (typeof value === "boolean") {
					formData.append(key, +value);
				} else if (Array.isArray(value)) {
					value.forEach((val) => {
						formData.append(key + "[]", val);
					});
				} else {
					formData.append(key, value);
				}
			});

			return formData;
		},
		async callSubmit (e) {
			await this.onSubmit(e);
		},
	},

};
</script>

<style>

</style>
